import { useRef, useState } from "react";
import { Play, Pause } from "lucide-react";
import { useFileUrl, recoverAudio } from "@/lib/media";

export function AudioPlayer({ path, src, label, testId = "audio-player", invite }) {
  const [signed, renew] = useFileUrl(src ? null : path, invite);
  const url = src || signed;
  const audioRef = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [progress, setProgress] = useState(0);

  const toggle = () => {
    const a = audioRef.current;
    if (!a) return;
    if (!a.paused) return a.pause();
    a.play().catch(() => { if (!src) recoverAudio(a, renew, true); });
  };
  if (!url) return null;

  return (
    <div className="flex items-center gap-4 rounded-2xl bg-[#1A1222] border border-[#33264A] p-4" data-testid={testId}>
      <audio
        ref={audioRef}
        src={url}
        onError={() => { if (!src && audioRef.current) recoverAudio(audioRef.current, renew); }}
        onPlay={() => setPlaying(true)}
        onPause={() => setPlaying(false)}
        onEnded={() => { setPlaying(false); setProgress(0); }}
        onTimeUpdate={(e) => {
          const a = e.target;
          setProgress(a.duration ? (a.currentTime / a.duration) * 100 : 0);
        }}
      />
      <button
        onClick={toggle}
        data-testid={`${testId}-toggle`}
        className="h-14 w-14 shrink-0 rounded-full gold-btn flex items-center justify-center"
      >
        {playing ? <Pause className="h-6 w-6" /> : <Play className="h-6 w-6 ml-0.5" />}
      </button>
      <div className="flex-1">
        {label && <p className="text-sm text-[#B9B3C8] mb-2">{label}</p>}
        <div className="h-1.5 rounded-full bg-[#2E2140] overflow-hidden">
          <div className="h-full bg-[#8B2CFF] transition-all" style={{ width: `${progress}%` }} />
        </div>
      </div>
    </div>
  );
}
